export default {
  getUser: 'GET_USER',
  requestLogin: 'REQUEST_LOGIN',
  loginSuccess: 'LOGIN_SUCCESS',
  logout: 'LOGOUT',
  loginError: 'LOGIN_ERROR',
}
